"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = isDefined;
exports.appendUnit = appendUnit;
exports.normalizeUnit = normalizeUnit;
function isDefined(v) {
    return v !== undefined;
}
function appendUnit(value, unit) {
    if (unit === undefined) {
        return `${value}`;
    }
    return `${value}${normalizeUnit(unit)}`;
}
function normalizeUnit(unit) {
    if (/^[\w#]/.test(unit)) {
        return ` ${unit}`;
    }
    return unit;
}
